// extracted by mini-css-extract-plugin
module.exports = {"wrapperModal":"modal_wrapperModal__1Yk5n","modal":"modal_modal__3YzSt"};